import { stampRequestStart } from '@payments-checkout/shared/observability';
import axios from 'axios';
import { env } from 'next-runtime-env';

export const mundipaggInstance = axios.create();

mundipaggInstance.interceptors.request.use(stampRequestStart);
mundipaggInstance.interceptors.request.use((config) => {
  config.baseURL = env('NEXT_PUBLIC_MUNDIPAGG_API') ?? '';
  return config;
});
